import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-amzn-spectrum-checklist',
  templateUrl: './help-amzn-spectrum-checklist.component.html',
  styleUrls: ['./help-amzn-spectrum-checklist.component.scss']
})
export class HelpAmznSpectrumChecklistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
